export default __webpack_public_path__ + "static/media/Message2.a5df28fa.png";